'use client';
import React from 'react';

interface DomainEntry {
  domain: string;
  count: number;
  pct: number;
}

interface AdminTopDomainsProps {
  domains: DomainEntry[];
}

export default function AdminTopDomains({ domains }: AdminTopDomainsProps) {
  const maxCount = Math.max(...domains.map(d => d.count));

  return (
    <div className="bg-card rounded-3xl border border-border shadow-card p-5 h-full">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="font-semibold text-foreground" style={{ fontSize: '15px' }}>Top Domains</h3>
          <p className="text-muted-foreground mt-0.5" style={{ fontSize: '12px' }}>Most-encoded URL domains</p>
        </div>
        <span className="badge badge-violet">{domains.length} domains</span>
      </div>

      <div className="space-y-3">
        {domains.map((domain, i) => (
          <div key={`domain-${domain.domain}`} className="group">
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2 min-w-0">
                <span
                  className="w-5 h-5 rounded-md flex-shrink-0 flex items-center justify-center text-white font-bold"
                  style={{
                    fontSize: '10px',
                    background: i === 0 ? '#F59E0B' : i === 1 ? '#94A3B8' : i === 2 ? '#CD7C2F' : 'var(--muted)',
                    color: i < 3 ? 'white' : 'var(--muted-foreground)',
                  }}
                >
                  {i + 1}
                </span>
                <span className="font-medium text-foreground truncate" style={{ fontSize: '13px' }}>{domain.domain}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0 ml-2">
                <span className="font-bold text-foreground" style={{ fontSize: '13px', fontVariantNumeric: 'tabular-nums' }}>{domain.count}</span>
                <span className="text-muted-foreground" style={{ fontSize: '11px' }}>{domain.pct}%</span>
              </div>
            </div>
            <div className="h-1.5 bg-secondary rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{
                  width: `${(domain.count / maxCount) * 100}%`,
                  background: i === 0
                    ? 'linear-gradient(90deg, #2563EB, #7C3AED)'
                    : i === 1
                    ? 'linear-gradient(90deg, #7C3AED, #0891B2)'
                    : 'var(--border)',
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}